import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../../../utils/styles";
import { EMPTY_VALUE } from "../../../../utils/value";

interface DetailsCardProps {
  icon?: React.ReactNode;
  title: string;
  fields: {
    name: string;
    value: string | number | null | undefined;
  }[];
  hideBottomBorder?: boolean;
}

export const DetailsCard = ({ icon, title, fields, hideBottomBorder }: DetailsCardProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        `border-t border-t-gray-200 border-dashed mt-4`,
        !hideBottomBorder && "border-b-gray-200 border-b",
      )}>
      <div className={`mt-9`}>
        <p className="flex justify-start items-center text-[13px] font-semibold leading-[16.38px] tracking-[1.5px] gap-2 text-black mb-8">
          {icon} {t(title).toUpperCase()}
        </p>
        <div className="flex flex-col justify-start gap-3">
          {fields?.[0] &&
            fields.map((field, index) => (
              <DetailsItem key={index} name={t(field?.name)} value={field?.value} />
            ))}
        </div>
      </div>
    </div>
  );
};

interface DetailsItemProps {
  name: string;
  value: string | number | null | undefined;
}

const DetailsItem = ({ name, value }: DetailsItemProps) => {
  return (
    <div className="flex flex-row justify-between">
      <p className="text-[16px] font-light leading-[20.16px] text-gray-550">{name}</p>
      <p className="text-[18px] font-medium leading-[22.68px] text-black">{value || EMPTY_VALUE}</p>
    </div>
  );
};
